import { gsap } from "gsap";

export default function projectArchiveEnterDesktop(data, isMobile, isTouch) {
  if (isMobile) {
    return gsap
      .timeline()
      .set(".wipe-wrapper", {
        autoAlpha: 0,
      })
      .set(data.next.container, {
        autoAlpha: 1,
      })
      .set(".hide-on-load", {
        autoAlpha: 1,
      })
      .from(".project-archive__header", {
        yPercent: -100,
      })
      .from(
        ".project-archive__header h1, .project-archive__header--selects--select",
        {
          xPercent: -10,
          autoAlpha: 0,
          delay: 0.25,
          stagger: 0.1,
        }
      )
      .from(".project-archive__list--item, .project-archive h2", {
        x: "100vw",
        stagger: 0.15,
      });
  }
  return gsap
    .timeline()
    .set(".wipe-wrapper", {
      autoAlpha: 0,
    })
    .set(data.next.container, {
      autoAlpha: 1,
    })
    .set(".hide-on-load", {
      autoAlpha: 1,
    })
    .from(".project-archive__header", {
      yPercent: -100,
    })
    .from(".project-archive__header h1", {
      xPercent: -20,
      autoAlpha: 0,
    })
    .from(".project-archive__header--selects", {
      xPercent: -20,
      autoAlpha: 0,
      delay: 0.25,
    })
    .from(
      ".project-archive__list--item",
      {
        autoAlpha: 0,
        yPercent: 10,
        stagger: 0.15,
      },
      "<"
    )
    .from(".project-archive h2", {
      autoAlpha: 0,
      yPercent: 10,
    });
}

function projectArchiveEnterDesktopBack(data, projectScroll) {
  return gsap.timeline()
  .set('.wipe-wrapper', {
    autoAlpha: 0
  })
  .set(data.next.container, {
    autoAlpha: 1
  })
  .to(window, {
    duration: 0.25, 
    scrollTo: projectScroll
  })
  .to('.hide-on-load', {
    autoAlpha: 1
  })
}

export { projectArchiveEnterDesktop, projectArchiveEnterDesktopBack };
